import { faSquareArrowUpRight } from '@fortawesome/pro-light-svg-icons'
import { CSSProperties, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate } from 'react-router'
import ModalRequestEmployeeAbsence from '../../../../../../app/erp/screens/BottomIcons/UserTimeControl/TimeControlEmployeeHolidays/ModalRequestEmployeeAbsence'
import ModalCreateCustomer from '../../../../../../app/erp/screens/Company/CustomerParent/AllCustomers/ModalCreateCustomer'
import ModalCreateCustomerB2C from '../../../../../../app/erp/screens/Company/CustomerParent/Customers/ModalCreateCustomer'
import ModalCreateCustomerB2B from '../../../../../../app/erp/screens/Company/CustomerParent/CustomersB2B/ModalCreateCustomerB2B'
import ModalCreateTaskBagOfHours from '../../../../../../app/erp/screens/Company/Tasks/TaskBagOfHours/ModalCreateTaskBagOfHours'
import ModalCreateQuoteOrder from '../../../../../../app/erp/screens/Logistic/QuoteParent/QuoteOrders/ModalCreateQuoteOrder'
import ModalCreateExpensesRequest from '../../../../../../app/erp/screens/Staff/ExpensesParent/ExpensesRequest/ModalCreateExpensesRequest'
import ModalCreateWCHolidayRequest from '../../../../../../app/erp/screens/Staff/WorkingCalendarParent/WorkingCalendarHolidayRequests/ModalCreateWCHolidayRequest'
import ModalCreateWCalOvertimeRequests from '../../../../../../app/erp/screens/Staff/WorkingCalendarParent/WorkingCalendarOvertimeRequests/ModalCreateWCalOvertimeRequests'
import ModalCreateTaskWithHelper from '../../../../../../specificComponents/Task/ModalCreateTaskWithHelper'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import useEditDeleteModal from '../../../../../../utils/hooks/useEditDeleteModal'
import useOnClickOutside from '../../../../../../utils/hooks/useOnClickOut'
import useShortcuts from '../../../../../../utils/hooks/useShorcuts'
import { dictIcon } from '../../../../../../utils/icons'
import { getConfigParam, getEmployeeQuickAccessParam, getUserInfo, getUserPermissions } from '../../../../../../utils/reducers/getters'
import { addBottomNavAppElement } from '../../../../../../utils/reducers/reduxDispatch'
import TwinIcon from '../../../../../TwinIcon'
import AddonListingModal from './Products/AddonsListingModal'
import AllCustomersListingModal from './CustomersListingModal/AllCustomersListingModal'
import CustomersB2BListingModal from './CustomersListingModal/CustomersB2BListingModal'
import CustomersB2CListingModal from './CustomersListingModal/CustomersB2CListingModal'
import MaterialsListingModal from './Products/MaterialListingModal'
import PackagingListingModal from './Products/PackagingListingModal'
import { AddonCreateModalShortcut, MaterialCreateModalShortcut, PackagingCreateModalShortcut, ProductCreateModalShortcut, ServiceCreateModalShortcut } from './Products/ProductCreateModalShortcuts'
import ProductListingModal from './Products/ProductListingModal'
import QuoteOrdersListingModal from './Orders/QuoteOrdersListingModal'
import ServiceListingModal from './Products/ServiceListingModal'
import { ShortCutActions, ShortcutIcon } from './types'
import { AllReduxAppPayloads, GlobalContext } from '../../../../../../utils/reducers'
import { connect, ConnectedProps } from 'react-redux'
import './shortcuticons.sass'

interface ShortcutsProps extends ShortcutsLogicProps { }

const Shortcuts: React.FC<ShortcutsProps> = ({...logic }) => {
    const { active, icons, changeActive, setOpenModal, openModal, handleClickIcon, ref } = useShortcutsLogic({ ...logic })
    const { ModalConverter} = useModalShortCuts()
    
    const MyModal = openModal?.allRowData?.modal ? ModalConverter[openModal?.allRowData?.modal].modal : null
    const userPermissions = openModal?.allRowData?.modal ? ModalConverter[openModal?.allRowData?.modal].userPermissions : null
    if (!icons || !icons.length) {
        return null
    }
    return (
        <div className='flex relative mt-24' ref={ref}>
            {active ? <ShortCutIconsDisplay icons={icons} handleClickIcon={handleClickIcon} /> : null}
            <div className='flex justify-center items-center'>
                <TwinIcon icon={faSquareArrowUpRight} onClick={changeActive} style={{ cursor: 'pointer' }} className='user_alerts_icons' />
            </div>
            {openModal?.type === 'edit' ? <MyModal setOpened={() => setOpenModal(null)} userPermissions={userPermissions} /> : null}
        </div>
    )
}

interface ShortcutsLogicProps extends ReduxShortcutConnector {}

const useShortcutsLogic = ({employee_quick_access }: ShortcutsLogicProps) => {
    const { shortcuts } = useShortcuts()
    const [active, setActive] = useState(false)
    const ref = useRef<any>(null)
    useOnClickOutside(ref, () => setActive(false))
    const [icons, setIcons] = useState<ShortcutIcon[]>([]);
    const { myActions, openModal, setOpenModal} = useModalShortCutActions()

    const handleClickIcon = useCallback((element: ShortcutIcon) => {
        myActions?.[element.action]?.(element)
        setActive(false)
    }, [myActions])

    const changeActive = useCallback(() => {
        setActive((old) => !old)
    }, [])
    
    useEffect(() => {
        setIcons(() => {
            const parsedParameter = getEmployeeQuickAccessParam()
            const filteredItem: ShortcutIcon[] = []
            for (const key in parsedParameter) {
                const element = parsedParameter[key]
                element[key] = shortcuts[element.action]
                filteredItem.push(element)
            }
            return filteredItem
        })
    }, [employee_quick_access, shortcuts])

    return { active, icons, changeActive, openModal, setOpenModal, handleClickIcon, ref }
}


const useModalShortCutActions = () => {
    const navigate = useNavigate()
    const { openModal, setOpenModal } = useEditDeleteModal()
    
    const createTask = useCallback(async () => {
        const user = getUserInfo()
        let WorkingCenterId = undefined
        const workingCenterByDefault = getConfigParam('assignTaskYourWorkingCenterByDefault')
        if (workingCenterByDefault && workingCenterByDefault === 'on') {
            WorkingCenterId = user?.WorkingCenterId
        }
        const createdTask = await twinFetchPostJSON('/api/app/task/createTask', { WorkingCenterId })
        if (createdTask) {
            addBottomNavAppElement({ type: 'taskModal', key: 'taskModal-' + createdTask.id, extraData: { id: createdTask.id, opened: true } })
        }
    }, [])

    const myActions: Record<ShortCutActions, Function> = useMemo(() => {
        return {
            navigate: (element: TwinDictionary) => navigate(`${element.actionParams}`),
            createCustomer: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ModalCreateCustomer' } }),
            listingAllCustomers: () => setOpenModal({ type: 'edit', allRowData: { modal: 'AllCustomersListingModal' } }),
            createCustomerB2B: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ModalCreateCustomerB2B' } }),
            listingCustomersB2B: () => setOpenModal({ type: 'edit', allRowData: { modal: 'CustomersB2BListingModal' } }),
            createCustomerB2C: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ModalCreateCustomerB2C' } }),
            listingCustomersB2C: () => setOpenModal({ type: 'edit', allRowData: { modal: 'CustomersB2CListingModal' } }),
            createProduct: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ProductCreateModalShortcut' } }),
            listingProducts: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ProductListingModal' } }),
            createPackaging: () => setOpenModal({ type: 'edit', allRowData: { modal: 'PackagingCreateModalShortcut' } }),
            listingPackagings: () => setOpenModal({ type: 'edit', allRowData: { modal: 'PackagingListingModal' } }),
            createService: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ServiceCreateModalShortcut' } }),
            listingServices: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ServiceListingModal' } }),
            createBagOfHours: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ModalCreateTaskBagOfHours' } }),
            createHolidayRequest: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ModalCreateWCHolidayRequest' } }),
            createEmployeeAbsence: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ModalRequestEmployeeAbsence' } }),
            createOvertimeRequest: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ModalCreateWCalOvertimeRequests' } }),
            createExpensesRequest: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ModalCreateExpensesRequest' } }),
            createMaterial: () => setOpenModal({ type: 'edit', allRowData: { modal: 'MaterialCreateModalShortcut' } }),
            listingMaterials: () => setOpenModal({ type: 'edit', allRowData: { modal: 'MaterialsListingModal' } }),
            createQuoteOrder: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ModalCreateQuoteOrder' } }),
            listingQuoteOrders: () => setOpenModal({ type: 'edit', allRowData: { modal: 'QuoteOrdersListingModal' } }),
            createAddon: () => setOpenModal({ type: 'edit', allRowData: { modal: 'AddonCreateModalShortcut' } }),
            listingAddons: () => setOpenModal({ type: 'edit', allRowData: { modal: 'AddonListingModal' } }),
            createTask: () => createTask(),
            createTaskHelper: () => setOpenModal({ type: 'edit', allRowData: { modal: 'ModalCreateTaskWithHelper' } })
        }
    }, [navigate, createTask, setOpenModal])
    return { openModal , myActions, setOpenModal}
}


const useModalShortCuts = () => {
    const ModalConverter: TwinDictionary = {
        'ModalCreateCustomer': { modal: ModalCreateCustomer, userPermissions: getUserPermissions('customer.profile.main') },
        'AllCustomersListingModal': { modal: AllCustomersListingModal, userPermissions: getUserPermissions('customer.profile.main') },
        'ModalCreateCustomerB2B': { modal: ModalCreateCustomerB2B, userPermissions: getUserPermissions('customer.profile.main') },
        'CustomersB2BListingModal': { modal: CustomersB2BListingModal, userPermissions: getUserPermissions('customer.profile.main') },
        'ModalCreateCustomerB2C': { modal: ModalCreateCustomerB2C, userPermissions: getUserPermissions('customer.profile.main') },
        'CustomersB2CListingModal': { modal: CustomersB2CListingModal, userPermissions: getUserPermissions('customer.profile.main') },
        'ProductCreateModalShortcut': { modal: ProductCreateModalShortcut, userPermissions: getUserPermissions('product.profile.main') },
        'ProductListingModal': { modal: ProductListingModal, userPermissions: getUserPermissions('product.profile.main') },
        'PackagingCreateModalShortcut': { modal: PackagingCreateModalShortcut, userPermissions: getUserPermissions('product.packaging.main') },
        'PackagingListingModal': { modal: PackagingListingModal, userPermissions: getUserPermissions('product.packaging.main') },
        'ServiceCreateModalShortcut': { modal: ServiceCreateModalShortcut, userPermissions: getUserPermissions('product.service.main') },
        'ServiceListingModal': { modal: ServiceListingModal, userPermissions: getUserPermissions('product.service.main') },
        'ModalCreateTaskBagOfHours': { modal: ModalCreateTaskBagOfHours, userPermissions: getUserPermissions('task.bagOfHours') },
        'ModalCreateWCHolidayRequest': { modal: ModalCreateWCHolidayRequest, userPermissions: getUserPermissions('WCal.holiday.usedDays') },
        'ModalRequestEmployeeAbsence': { modal: ModalRequestEmployeeAbsence, userPermissions: getUserPermissions('WCal.absences.control') },
        'ModalCreateWCalOvertimeRequests': { modal: ModalCreateWCalOvertimeRequests, userPermissions: getUserPermissions('WCal.overtime') },
        'ModalCreateExpensesRequest': { modal: ModalCreateExpensesRequest, userPermissions: getUserPermissions('expenses.main') },
        'MaterialCreateModalShortcut': { modal: MaterialCreateModalShortcut, userPermissions: getUserPermissions('product.material.main') },
        'MaterialsListingModal': { modal: MaterialsListingModal, userPermissions: getUserPermissions('product.material.main') },
        'ModalCreateQuoteOrder': { modal: ModalCreateQuoteOrder, userPermissions: getUserPermissions('quote.order') },
        'QuoteOrdersListingModal': { modal: QuoteOrdersListingModal, userPermissions: getUserPermissions('quote.order') },
        'AddonCreateModalShortcut': { modal: AddonCreateModalShortcut, userPermissions: getUserPermissions('product.addon.main') },
        'AddonListingModal': { modal: AddonListingModal, userPermissions: getUserPermissions('product.addon.main') },
        'ModalCreateTaskWithHelper': { modal: ModalCreateTaskWithHelper, userPermissions: getUserPermissions('task.main') },
    }
    return { ModalConverter }
}


interface ShortCutIconsDisplayProps {
    icons: ShortcutIcon[]
    handleClickIcon: (element: ShortcutIcon) => void
}

const ShortCutIconsDisplay: React.FC<ShortCutIconsDisplayProps> = ({ icons, handleClickIcon }) => {
    const renderThis: JSX.Element[] = []
    let column = 0
    let numIcons = 3
    const base = 270
    let row = 1
    for (const key in icons) {
        const element = icons[key]
        const deg = column === 0 ? base : base + (90 / (numIcons - 1) * column)
        const translate = row === 1 ? 4.2 : (row * 4)

        const style: CSSProperties = {
            transform: 'rotate(' + deg + 'deg) translate(' + translate + 'em) rotate(-' + deg + 'deg)',
            cursor: 'pointer'
        }
        renderThis.push(
            <div className='rounded_icons text-gray-51' style={style} key={key} onClick={() => handleClickIcon(element)}>
                <TwinIcon icon={dictIcon[element.icon]} size="2x" className='singleIcon' />
            </div>
        )
        column++;
        if (column === numIcons) {
            if (row >= 1) {
                numIcons++
            }
            numIcons++
            row++
            column = 0;
        }
    }
    return (
        <div className = 'flex absolute z-1 shortcut_circle_icons' >
            {renderThis}
        </div >
    )
}



const mapShortcutBaseConnector = (state: AllReduxAppPayloads) => ({ employee_quick_access: state.user?.extraData?.Employee?.EmployeeParameters?.employee_quick_access })
export const shortcutConnector = connect(mapShortcutBaseConnector, {}, null, { context: GlobalContext })
export type ReduxShortcutConnector = ConnectedProps<typeof shortcutConnector>
const ShortcutsConnect = shortcutConnector(Shortcuts)

export default ShortcutsConnect



